import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, ResolveFn } from '@angular/router';
import { finalize, first } from 'rxjs';
import { LoadingDefaults } from '../../../shared/models/loading-defaults.model';
import {
  DeploymentResponse,
  DeploymentsClient,
} from '../../../shared/services/api-client';
import { RplLoadingService } from '../../../shared/services/rpl-loading.service';

export const deploymentResolver: ResolveFn<DeploymentResponse> = (
  route: ActivatedRouteSnapshot,
) => {
  const client = inject(DeploymentsClient);
  const loadingService = inject(RplLoadingService);

  const id = Number(route.paramMap.get('deploymentId'));

  let loadingId: string | undefined;
  const timeout = setTimeout(() => {
    loadingId = loadingService.start();
  }, LoadingDefaults.StartIndicatorTimeout);

  return client.getDeploymentById(id).pipe(
    first(),
    finalize(() => {
      clearTimeout(timeout);
      loadingService.end(loadingId);
    }),
  );
};
